import { adjustColorGroup as e, semanticColorGroups as o } from "./index36.mjs";
const b = (n) => {
  const t = Object.entries(
    e(n.oldBrandPrimary, o[0])
  ).map(([r, a]) => `${r}: ${a};`).join(`
`), i = Object.entries(
    e(n.oldTextPrimary, o[1])
  ).map(([r, a]) => `${r}: ${a};`).join(`
`), s = Object.entries(
    e(n.oldBackgroundPrimary, o[2])
  ).map(([r, a]) => `${r}: ${a};`).join(`
`), d = Object.entries(
    e(n.oldBackgroundHeader, o[3])
  ).map(([r, a]) => `${r}: ${a};`).join(`
`);
  return `
        ${[
    t,
    i,
    s,
    d
  ].join(`

`)}
    `;
};
export {
  b as getRootVarsByBrandColors
};
